import type {PS} from '@wix/document-services-types'

export default {
    /**
     * @param {PS} ps
     * @returns {boolean}
     */
    get(ps: PS): boolean {
        return ps.extensionAPI.accessibility.skipToContent.get()
    },
    /**
     * @param {PS} ps
     * @param {boolean} enabled
     */
    set(ps: PS, enabled: boolean): void {
        ps.extensionAPI.accessibility.skipToContent.set(enabled)
    }
}
